import { makeStyles } from 'tss-react/mui';

const name = 'Header';

export const useHeaderStyles = makeStyles({ name })(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
  },
  label: {
    margin: 0,
  },
}));
